const middleware = {}

middleware['access-logs'] = require('../middleware/access-logs.js')
middleware['access-logs'] = middleware['access-logs'].default || middleware['access-logs']

middleware['update'] = require('../middleware/update.js')
middleware['update'] = middleware['update'].default || middleware['update']

export default middleware
